import React from 'react'

import {useConfigData} from '../../shared/hooks'

import {ShiftsRequiredErrorPage} from './ShiftsRequiredErrorPage'

type Props = {
  children?: React.ReactNode
  goToLink?: string
}

export const PlantShiftsGuardedRoute = ({children, goToLink}: Props) => {
  const {shifts} = useConfigData()

  if (!shifts?.length) {
    return <ShiftsRequiredErrorPage goToLink={goToLink} />
  }

  return <>{children}</>
}
